// extracted by mini-css-extract-plugin
module.exports = {"workDot":"AgentsIslandBadge_workDot__dNS_5","islandWorkBreathe":"AgentsIslandBadge_islandWorkBreathe__1hJWz"};